var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFootwear = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 84,
    height: 84
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.258 48.294c1.75-2.286 3.063-7.168-.578-8.474l-5.732-1.977-3.754-1.297.236-.275a.849.849 0 0 0-.148-1.163.887.887 0 0 0-1.19.063l-.657.764-2.039-.696c1.024-.86-.184-2.269-1.146-1.332l-.622.722-2.03-.705.157-.137a.85.85 0 0 0-.105-1.212.888.888 0 0 0-1.233.103l-.57.662-2.03-.696.097-.12a.849.849 0 0 0-.15-1.163.887.887 0 0 0-1.19.063l-.524.61-1.514-.525a3.56 3.56 0 0 0-3.098.396l-2.486 1.641c-3.216 2.112-7.56 1.309-9.775-1.805a1.76 1.76 0 0 0-1.435-.73c-.805.043-2.424-.223-2.993.55A10.046 10.046 0 0 0 18 38.436v6.79c-.061 3.438 2.748 6.875 6.38 6.772h33.465c2.932.002 5.688-1.375 7.412-3.704Zm0-5.26c0 1.39-.407 2.75-1.173 3.919H44.701V44.65a1.71 1.71 0 0 1 .78-1.41l2.782-1.839 1.68.636c1.72.653 3.65.511 5.251-.387l3.64-2.02 5.251 1.831c.685.234 1.151.86 1.173 1.573Zm-22.43 3.919-5.47-2.149v-2.423a1.708 1.708 0 0 1 .77-1.461l3.265-2.148 4.883 1.89-1.75 1.169a3.423 3.423 0 0 0-1.549 2.853v2.303l-.149-.034Zm-22.753 0c-.552-1.135-.245-5.965-.324-7.228l4.936 1.942c.549 1.82.168 3.79-1.024 5.286h-3.588Zm6.607-4.52 11.447 4.52H25.746a7.555 7.555 0 0 0 .945-3.653c0-.292-.026-.575-.052-.867h.043Zm11.727-9.136c.718-.541 1.69-.163 2.433.12l-.429.49a.848.848 0 0 0-.129.922c.147.305.46.5.803.496.578.069 1.173-.97 1.514-1.306l2.04.705-.377.447a.849.849 0 0 0 .148 1.162.887.887 0 0 0 1.19-.062l.797-.937 2.04.705-.333.386a.847.847 0 0 0-.123.911c.142.301.449.497.788.499.577.069 1.094-.86 1.435-1.195l2.03.705-.289.335a.849.849 0 0 0-.12.915.877.877 0 0 0 .794.494c.56.07 1.05-.807 1.383-1.134l2.625.86-2.31 1.28a4.44 4.44 0 0 1-3.737.275l-14.571-5.483 2.398-1.59Zm-16.373-.567h1.75a8.869 8.869 0 0 0 4.52 3.257 9.023 9.023 0 0 0 5.605-.052l5.487 2.08-2.249 1.487a3.422 3.422 0 0 0-1.54 2.88V44.1l-15.857-6.214a8.331 8.331 0 0 1 2.284-5.156Zm2.345 17.584a4.344 4.344 0 0 1-3.396-1.642h41.543a7.48 7.48 0 0 1-4.682 1.642H24.381Z",
    fill: "currentColor"
  }))));
};
export { SvgFootwear as ReactComponent };